// extracted by mini-css-extract-plugin
export default {"cls1":"gbtq6NesoC70CNl2z_zU","cls2":"tB_5RlWPsyVCPpHBHgg7 gbtq6NesoC70CNl2z_zU","isPhone":"leq9vPMkpMs4iZTKxINy"};